import type { Pagination } from 'models';
import { useEffect, useState } from 'react';
import type { VideosListFilter } from '../../../models';
import { useVideosInfiniteQuery } from '../../../queries';

// TODO: rename
export const useVideos = ({
  allowUnfeatured,
  filter,
  pagination,
}: {
  allowUnfeatured?: boolean;
  filter?: VideosListFilter;
  pagination: Omit<Pagination, 'position'>;
}) => {
  const [isFeatured, setIsFeatured] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsFeatured(true);
  }, [filter?.organizationId]);

  const query = useVideosInfiniteQuery({
    filter: { featured: isFeatured, ...filter },
    pagination,
  });

  useEffect(() => {
    if (isFeatured && allowUnfeatured && query.data?.pages[0]?.data.length === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsFeatured(false);
    }
  }, [isFeatured, allowUnfeatured, query.data?.pages]);

  return { isFeatured, query };
};
